// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../../global/styles/buttonStyles";
import type { IconStylesClassesType } from "../../../global/styles/iconStyles";
import { buttonStyles } from "../../../global/styles/buttonStyles";
import { iconStyles } from "../../../global/styles/iconStyles";
import ExportToCsv from "../../../global/functions/ExportCsv";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  ...iconStyles(theme),
  rightMargin: {
    marginRight: "5px"
  }
});

type ExportCsvButtonClassesType = {
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  rightMargin: DictionaryType
};

type ExportCsvButtonPropsType = {
  classes: ExportCsvButtonClassesType,
  searchList: Array<*>,
  displayTags: boolean
};

class ExportCsvButton extends Component<ExportCsvButtonPropsType, *> {
  exportCsv = (): * => {
    const searchList = this.props.searchList;

    let csvArray = [
      [
        "Person Name",
        "Person UUID",
        "Enrolment UUID",
        "Probability",
        "Match Quality"
      ]
    ];
    if (this.props.displayTags) {
      csvArray[0].push("Tags");
    }
    if (searchList) {
      searchList.forEach((item: *) => {
        let row = [
          item.person_name,
          item.person_uid,
          item.enrolment_uid,
          item.probability,
          item.match_quality
        ];
        if (this.props.displayTags) {
          row.push(JSON.stringify(item.tags));
        }
        csvArray.push(row);
      });
    }
    const fileName = `imagus-face-search_${new Date(
      Date.now()
    ).toLocaleString()}`;

    ExportToCsv(fileName, csvArray);
  };

  render(): * {
    const classes = this.props.classes;

    return (
      <Button
        type="button"
        variant="contained"
        color="primary"
        className="dark-btn"
        onClick={this.exportCsv}
      >
        <CloudDownloadIcon
          className={classNames(classes.darkBtn, classes.rightMargin)}
        />
        Export to CSV
      </Button>
    );
  }
}

export default withStyles(styles)(ExportCsvButton);
